import React, { useState, useEffect } from 'react';
import { useContext } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import Accordion from '@components/Accordion';
import Field from '@components/Field';
import { MinusIcon } from '@assets/icons/minusIcon';
import { KeyBoardIcon } from '@assets/icons/keyBoardIcon';
import KeyboardShortcuts from '../KeyboardShortcuts'
import { Context } from '@routes/private/Editor/Context';
import { ITemplateFields, ITaggedField } from '@routes/private/Editor/types';
import { GetTaggedElements, GetTotalTaggedCategories } from '@utils/selectDescribe';
import { IField } from '@state/dsconfig/types';
import { getEndNumber } from 'utils/selectDescribe';

const Categories:React.FC<IProps> = (props) => {
  const context = useContext(Context);
  const [category, setCategory] = useState(0);
  const [subCategory, setSubCategory] = useState(-1);
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const [templateFields, setTemplateFields] = useState<ITemplateFields[]|undefined>();
  const [taggedFields, setTaggedFields] = useState<ITaggedField[]|undefined>();
  const [categoryIdSelected, setCategoryIdSelected] = useState<string | undefined>();
  const updatedFieldTagsResponse = useSelector(selectors.parsedTrees.getUpdatedFieldTagsResponse);
  const updatedTemplateFieldsResponse = useSelector(selectors.parsedTrees.getUpdatedTemplateFieldsResponse);

  useEffect(() => {
    if (updatedFieldTagsResponse) context.onSavingParsedTree(false);
  }, [updatedFieldTagsResponse]);

  useEffect(() => {
    if (updatedTemplateFieldsResponse) context.onSavingParsedTree(false);
  }, [updatedTemplateFieldsResponse]);

  useEffect(() => {
    setSubCategory(-1);
  }, [category])

  useEffect(() => {
    if(context.selectDescribe){
      setTemplateFields(context.selectDescribe?.templateFields);
    }
  }, [context.selectDescribe?.templateFields])

  useEffect(() => {
    if(context.selectDescribe){
      setTaggedFields(context.selectDescribe?.taggedFields);
    }
  }, [context.selectDescribe?.taggedFields])

  useEffect(() => {
    if(context.editorStatus){
      setCategoryIdSelected(context.editorStatus.selectedSelectDescribeCategoryId);
    }
  }, [context.editorStatus.selectedSelectDescribeCategoryId])

  function GetMessageField(id: string,taggedCategory?: ITaggedField): string {
    if(taggedCategory && taggedCategory.taggedElements && taggedCategory.taggedElements.length>0)
    {
      return taggedCategory.taggedElements.length.toString() + " selected"; 
    }
    return "";
  }

  function GetMessageSection(id: string, taggedCategories?: ITaggedField[], parentCategories?: IField[], templateCategories?: ITemplateFields[]): string {
    if(taggedCategories)
    {
      return "(" + GetTotalTaggedCategories(id, taggedCategories, parentCategories, templateCategories).toString() + ")"; 
    }
    return "(0)";
  }

  const contentTemplateCategories = (parentFieldId: string) => {
    return templateFields?.filter((category)=> category.parentId === parentFieldId).sort((category1,category2)=>{
      if(getEndNumber(category1.name)!<getEndNumber(category2.name)!){
        return -1;
      }
      else if(getEndNumber(category1.name)!>getEndNumber(category2.name)!){
        return 1;
      }
      return 0;
    }).map((fieldCategory:ITemplateFields) => {      
      return <Field selected={categoryIdSelected==fieldCategory.id} onClick={() => context.onSelectedSelectDescribeCategoryIdChange(categoryIdSelected === fieldCategory.id ? undefined : fieldCategory.id)} onClearAll={() => context.onSelectDescribeCategoryClearAll(fieldCategory.id)} messageText={GetMessageField(fieldCategory.id,GetTaggedElements(fieldCategory.id,taggedFields))} showSaving={categoryIdSelected==fieldCategory.id && context.saveStatus.updatingSelectDescribeTaggedElements} icon={<MinusIcon onClick={()=> context.onTemplateCategoryRemoved(fieldCategory.id)} style={{cursor: 'pointer', marginLeft: '22px', marginRight: '7px', overflow: 'initial'}}/>} title={fieldCategory.name}/>;
    });
  };

  const contentFields = (fields: any) => {
    return fields.map((field:any) => {      
      return <><Field selected={categoryIdSelected==field.id} onClick={() => context.onSelectedSelectDescribeCategoryIdChange(categoryIdSelected === field.id ? undefined : field.id)} onClearAll={() => context.onSelectDescribeCategoryClearAll(field.id)} messageText={GetMessageField(field.id,GetTaggedElements(field.id,taggedFields))} onIconClick={() => context.onTemplateCategoryAdded(field.id, field.name)} title={field.name} showSaving={categoryIdSelected==field.id && context.saveStatus.updatingSelectDescribeTaggedElements}/>
              {
                contentTemplateCategories(field.id)
              }
             </>;
    });
  }

  return (
    <S.Root>
      <S.Categories>
        {dsConfig?.selectDescribeConfig &&
          dsConfig?.selectDescribeConfig.categories.map((cat:any, index:number) => 
            <S.Category onClick={()=>{setCategory(index);context.onSelectedSelectDescribeCategoryIdChange(undefined);}} active={category===index} index={index}>{cat.name}</S.Category>
          )
        }
      </S.Categories>
      <S.Fields>
        {dsConfig?.selectDescribeConfig.categories[category].fields.map((field:any, index:number) => {
              if (field.fields?.length>0) {
                return <Accordion
                        index={index}
                        title={field.name}
                        active={subCategory==index}
                        message={GetMessageSection(field.id,taggedFields,field.fields,templateFields)}
                        onClick={()=> {
                          if (index!==subCategory) setSubCategory(index);
                          else setSubCategory(-1);
                          context.onSelectedSelectDescribeCategoryIdChange(undefined);
                        }}>
                          {field.fields && contentFields(field.fields)}
                      </Accordion>;
              }
              else return <S.Container>
                            <Field selected={categoryIdSelected==field.id} onClick={() => context.onSelectedSelectDescribeCategoryIdChange(categoryIdSelected === field.id ? undefined : field.id)} onClearAll={() => context.onSelectDescribeCategoryClearAll(field.id)} messageText={GetMessageField(field.id,GetTaggedElements(field.id,taggedFields))} onIconClick={() => context.onTemplateCategoryAdded(field.id, field.name)} showSaving={categoryIdSelected==field.id && context.saveStatus.updatingSelectDescribeTaggedElements} title={field.name}/>
                            {
                              contentTemplateCategories(field.id)
                            }
                          </S.Container>;
              })}
      </S.Fields>
      <KeyboardShortcuts>
        <S.Shortcuts>
          Keyboard Shortcuts
          <KeyBoardIcon style={{marginLeft: '16.3px'}}/>
        </S.Shortcuts>
      </KeyboardShortcuts>
    </S.Root>
  );
}

export default Categories;